import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { CategoryContainer, CategoryHeading } from './style.js';
import ToggleButtonGroup from './ToggleButtonGroup.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var _excluded = ["parentCategoryIDs"];
var ToggleButtonGroups = function ToggleButtonGroups(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? null : _ref$className,
    items = _ref.items,
    _ref$categories = _ref.categories,
    categories = _ref$categories === void 0 ? [] : _ref$categories,
    handleChange = _ref.handleChange,
    _ref$allButtonText = _ref.allButtonText,
    allButtonText = _ref$allButtonText === void 0 ? null : _ref$allButtonText,
    _ref$allButtonBehavio = _ref.allButtonBehaviour,
    allButtonBehaviour = _ref$allButtonBehavio === void 0 ? 'reflectAndToggleState' : _ref$allButtonBehavio,
    _ref$removeAllButton = _ref.removeAllButton,
    removeAllButton = _ref$removeAllButton === void 0 ? false : _ref$removeAllButton;
  var hasCategories = categories.length > 0;
  var categoriesAndItems = categories.map(function (category) {
    var categoryItems = (items === null || items === void 0 ? void 0 : items.filter(function (item) {
      var _item$parentCategoryI;
      return (_item$parentCategoryI = item.parentCategoryIDs) === null || _item$parentCategoryI === void 0 ? void 0 : _item$parentCategoryI.includes(category.id);
    }).map(function (_ref2) {
      _ref2.parentCategoryIDs;
        var item = _objectWithoutProperties(_ref2, _excluded);
      return item;
    })) || [];
    return {
      id: category.id,
      title: category.title,
      items: categoryItems
    };
  }).filter(function (category) {
    return category.items.length > 0;
  });
  return /*#__PURE__*/jsxs("div", {
    className: className,
    children: [!hasCategories && /*#__PURE__*/jsx(ToggleButtonGroup, {
      items: items,
      handleChange: handleChange,
      allButtonText: allButtonText,
      allButtonBehaviour: allButtonBehaviour,
      removeAllButton: removeAllButton
    }), hasCategories && categoriesAndItems.map(function (category) {
      var id = category.id,
        title = category.title,
        categoryItems = category.items;
      return /*#__PURE__*/jsxs(CategoryContainer, {
        children: [/*#__PURE__*/jsx(CategoryHeading, {
          children: title
        }), /*#__PURE__*/jsx(ToggleButtonGroup, {
          items: categoryItems,
          handleChange: handleChange,
          allButtonText: allButtonText,
          allButtonBehaviour: allButtonBehaviour,
          removeAllButton: removeAllButton
        })]
      }, id);
    })]
  });
};
var ToggleButtonGroups$1 = ToggleButtonGroups;

export { ToggleButtonGroups$1 as default };
//# sourceMappingURL=ToggleButtonGroups.js.map
